export default __webpack_public_path__ + "static/GT-Super-Display-Light-4495c388994f43cf2100c1247e645e3f.woff";